export const EXTERNAL_LINK = {
  AIRTABLE: 'https://airtable.com/shrEnYEjymZ7LXEUT',
  BOOKING_TIME: 'https://doodle.com/bp/babysisters1/book-a-time',
  TERMS_AND_CONDITIONS:
    'https://www.notion.so/BABY-SISTERS-Termos-Condi-es-Terms-Conditions-fff0130dc80b81b2885bdc7d223dc7fa',
}
